import { Layout } from "react-admin";
import Menu from "./Menu.jsx";
import MyAppBar from './MyAppBar';

const MyLayout = (props) => {
  // const [isDragging, setIsDragging] = useState(false);


  return (
    <div>

      <Layout
        appBar={MyAppBar}
        {...props}
        menu={Menu}
      >

      </Layout>
      {/* <Draggable
        handle=".handle"
        defaultPosition={{ x: 0, y: 0 }}
        position={null}
        scale={1}
        onStart={() => setTimeout(() => setDragging(true), PRESS_TIME_UNTIL_DRAG_MS)}
        onDrag={e => {
          if (isDragging === false) {
            e.preventDefault()
            return false
          }
        }}
        // onStart={this.handleStart}
        // onDrag={this.handleDrag}
        onStop={e => {
          setDragging(false)
        }}
      >
        <div className="handle" style={{ position: "fixed", left: "190px", bottom: "60px", zIndex: 1000, width: "56px", height: "56px" }}>
          <Fab
            class="hvr-buzz hvr-icon-wobble-vertical"
            style={{
              color: "primary", backgroundColor: "yellow",borderRadius:"10px", width: "56px", height: "56px" ,
            }}

            onClick={(e) => {
              // if (e) { }
              if (isDragging === false) {
                e.preventDefault();
                window.location.href = ADMIN_DOMAIN+"/#/reminder/create";
              }

            }}
                   >
            <EditNotificationsIcon style={{
              color: "primary", backgroundColor: "transparent", width: "36px", height: "36px"
            }}
              color="primary" />

          </Fab>
        </div>
      </Draggable> */}

    </div>

  )
};

export default MyLayout;
